import * as tabs from "./_components/tabs/index"

if (document.querySelector(".internal-tabs")) {
    tabs.init()
}
